import { buildHeadshotBlock, buildLinkResetHeader, buildSocialIconTd } from './shared';

export default (brand) => ({
  id: 4,
  name: 'Template #5',
  height: 170,
  params: [
    'name',
    'title',
    'address',
    'email',
    'mobile',
    'office',
    'website',
    'facebook',
    'instagram',
    'linkedin',
    'twitter'
  ],
  source: `${buildLinkResetHeader({ text: brand.text })}

<table id="body" cellpadding="0" cellspacing="0" style="width: 600px;border-collapse: collapse;" width="600" border="0">
  <tr>
    <td valign="middle" style="width: 142px;padding-right: 24px;" width="142">
      <table cellpadding="0" cellspacing="0" style="width: 142px;" width="142" border="0">
        
          <tr>
            <td align="center">
${buildHeadshotBlock({ indent: 14, size: 132, borderWidth: 5, ovalStyleDims: 'height: auto; width: 132px;', primary: brand.primary })}
            </td>
          </tr>
        
        <tr>
          <td align="center" style="padding-top: 5px;">
            <a href="{{ website }}" target="_blank" style="text-decoration: none;display: inline-block;">
              <img
                src="${brand.logoUrl}"
                alt="Company logo"
                style="width: 140px;height: auto;display: block;border: 0;outline: none;"
                width="140"
              >
            </a>
          </td>
        </tr>
      </table>
    </td>
    <td valign="middle" style="width: 434px;" width="434">
      <table cellpadding="0" cellspacing="0" style="width: 434px;" width="434" border="0">
        <tr>
          <td valign="middle" style="width: 138px;padding-right: 8px;" width="138">
            <table cellpadding="0" cellspacing="0" style="width: 138px;" width="138" border="0">
              {% if name %}
                <tr>
                  <td style="color: ${brand.text}; font-size: 24px; font-family: Helvetica, Arial, sans-serif; line-height: 30px; mso-line-height-rule: exactly;">
                    <b>{{ name }}</b>
                  </td>
                </tr>
              {% endif %}
              {% if title %}
                <tr>
                  <td style="color: ${brand.text}; font-size: 12px; font-family: Helvetica, Arial, sans-serif; line-height: 20px; mso-line-height-rule: exactly;">
                    <b>{{ title }}</b>
                  </td>
                </tr>
              {% endif %}
              <tr>
                <td style="padding-top: 8px;">
                  <table cellpadding="0" cellspacing="0" border="0">
                    <tr>
${buildSocialIconTd({ indent: 24, field: 'facebook', type: 'facebook', alt: 'facebook', background: 'none', color: brand.primaryNoHash, radius: 4 })}
${buildSocialIconTd({ indent: 24, field: 'instagram', type: 'instagram', alt: 'instagram', background: 'none', color: brand.primaryNoHash, radius: 4 })}
${buildSocialIconTd({ indent: 24, field: 'linkedin', type: 'linkedin', alt: 'linkedin', background: 'none', color: brand.primaryNoHash, radius: 4 })}
${buildSocialIconTd({ indent: 24, field: 'twitter', type: 'x', alt: 'twitter', background: 'none', color: brand.primaryNoHash, radius: 4 })}
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
          <td valign="middle" style="width: 270px;padding-left: 16px;border-left: 2px solid #ededed;" width="270">
            <table cellpadding="0" cellspacing="0" style="width: 270px;" width="270" border="0">
              {% if address %}
                <tr>
                  <td valign="top" style="padding-top: 2px;">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="middle" style="width: 22px;padding-right: 5px;" width="22">
                          <img
                            src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=address&background=none&color=${brand.primaryNoHash}&size=22&radius=4"
                            alt="location"
                            style="width: 22px;height: 22px;display: block;border: 0;"
                            width="22"
                            height="22"
                          >
                        </td>
                        <td valign="middle" style="line-height: 22px;">
                          <span style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;">
                            {{ address }}
                          </span>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              {% endif %}
              {% if email %}
                <tr>
                  <td valign="top" style="padding-top: 2px;">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="middle" style="width: 22px;padding-right: 5px;" width="22">
                          <img
                            src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=email&background=none&color=${brand.primaryNoHash}&size=22&radius=4"
                            alt="email"
                            style="width: 22px;height: 22px;display: block;border: 0;"
                            width="22"
                            height="22"
                          >
                        </td>
                        <td valign="middle" style="line-height: 22px;">
                          <a
                            href="mailto:{{email}}"
                            style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                          >
                            {{ email }}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              {% endif %}
              {% if mobile %}
                <tr>
                  <td valign="top" style="padding-top: 2px;">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="middle" style="width: 22px;padding-right: 5px;" width="22">
                          <img
                            src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=mobile&background=none&color=${brand.primaryNoHash}&size=22&radius=4"
                            alt="mobile"
                            style="width: 22px;height: 22px;display: block;border: 0;"
                            width="22"
                            height="22"
                          >
                        </td>
                        <td valign="middle" style="line-height: 22px;">
                          <a
                            href="tel:{{mobile}}"
                            style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                          >
                            {{ mobile }}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              {% endif %}
              {% if office %}
                <tr>
                  <td valign="top" style="padding-top: 2px;">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="middle" style="width: 22px;padding-right: 5px;" width="22">
                          <img
                            src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=phone&background=none&color=${brand.primaryNoHash}&size=22&radius=4"
                            alt="phone"
                            style="width: 22px;height: 22px;display: block;border: 0;"
                            width="22"
                            height="22"
                          >
                        </td>
                        <td valign="middle" style="line-height: 22px;">
                          <a
                            href="tel:{{office}}"
                            style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                          >
                            {{ office }}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              {% endif %}
              {% if website %}
                <tr>
                  <td valign="top" style="padding-top: 2px;">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="middle" style="width: 22px;padding-right: 5px;" width="22">
                          <img
                            src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=website&background=none&color=${brand.primaryNoHash}&size=22&radius=4"
                            alt="web"
                            style="width: 22px;height: 22px;display: block;border: 0;"
                            width="22"
                            height="22"
                          >
                        </td>
                        <td valign="middle" style="line-height: 22px;">
                          <a
                            href="{{ website }}"
                            style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                          >
                            {{ website }}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              {% endif %}
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>`
});
